import React from "react";
import { connect } from "react-redux";

const ClassC000112 = () => {
  return <div style={{ padding: "20px" }}>建構中</div>;
};

export default connect((state) => ({ user: state.user }), {})(ClassC000112);
